export default __webpack_public_path__ + "static/responsible-consumption-f71510a3f3ccb1c0716487cedb25ccc8.png";